import { Flex, Span } from "@goodfill/ui-components";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";
import { pricedBondState } from "../../../state";
import { PricedBond } from "../PricedBond";
import { filterSimilarBonds } from "./filterSimilarBonds";
import { SimilarBondCard } from "./SimilarBondCard";

export const SimilarBonds = ({ pricedBond }: { pricedBond: PricedBond }) => {
  const pricedBonds = useRecoilValue(pricedBondState);

  const { t } = useTranslation();

  const filtered = filterSimilarBonds(pricedBond, [...pricedBonds.values()]);

  return (
    <div className="flex flex-col gap-4 md:gap-8 items-center my-20">
      <div className="flex justify-center">
        <Span primary={true} font="bold" size="4xl">
          {t("similarBonds")}
        </Span>
      </div>
      <div className="flex flex-col md:flex-row gap-3 md:gap-6 justify-center flex-wrap">
        {filtered.map((similarBond) => (
          <SimilarBondCard key={`${similarBond.bondIdCusip}`} pricedBond={similarBond} />
        ))}
      </div>
    </div>
  );
};
